module.exports = {
  LIBRARY_SCOPE: 'affiliates_library',
  LIBRARY_MODULES_NAMES: {
    RENDERER_DESKTOP: 'renderer-desktop',
    RENDERER_MOBILE: 'renderer-mobile',
  },
  LIBRARY_MODULE_NAME_PATH_PREFIX: './',

  // eslint-disable-next-line no-nested-ternary
  LIBRARY_REMOTE_ENTRY_END_POINT: __PROD__
    ? 'https://assets.toiimg.com/affiliates/library/remoteEntry.js'
    : __STAGING__
    ? 'https://assets.toiimg.com/affiliates/library/staging/remoteEntry.js'
    : 'http://localhost:9001/remoteEntry.js',

  WIDGET_FEED_END_POINT: __PROD__
    ? 'https://timesofindia.indiatimes.com/affiliates_library_widgets_feed.cms?feedtype=json'
    : 'https://toidev.indiatimes.com/affiliates_library_widgets_feed.cms?feedtype=json',

  WIDGET_FEED_END_POINT_V2: __PROD__
    ? 'https://jarvis.indiatimes.com/v1/feeds'
    : 'https://jarvis-stg.indiatimes.com/v1/feeds',
}
